"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Container = _interopRequireDefault(require("@material-ui/core/Container"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _styles = require("@material-ui/core/styles");

var _Ladder = _interopRequireDefault(require("../../Carousels/Ladder"));

var _Focal = _interopRequireDefault(require("../Focal"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var useStyle = (0, _styles.makeStyles)(function (theme) {
  return {
    root: function root(_ref) {
      var reverseOnMobile = _ref.reverseOnMobile;
      return _defineProperty({
        flexDirection: 'row-reverse',
        flexWrap: 'nowrap',
        height: '100%'
      }, theme.breakpoints.down('sm'), {
        height: 'auto',
        flexDirection: reverseOnMobile ? 'column' : 'column-reverse'
      });
    },
    wrapper: {
      height: '100%'
    }
  };
});

var Neapolitan = function Neapolitan(_ref3) {
  var carousel = _ref3.carousel,
      focalComponent = _ref3.focalComponent,
      navComponent = _ref3.navComponent,
      children = _ref3.children,
      reverseOnMobile = _ref3.reverseOnMobile,
      rest = _objectWithoutProperties(_ref3, ["carousel", "focalComponent", "navComponent", "children", "reverseOnMobile"]);

  var cls = useStyle({
    reverseOnMobile: reverseOnMobile
  });
  return /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    className: cls.wrapper,
    maxWidth: "xl",
    disableGutters: true,
    component: "main"
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], _extends({
    className: cls.root,
    container: true
  }, rest), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: true
  }, navComponent, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    lg: true,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    p: 1
  }, children)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    lg: "auto",
    sm: 12
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    p: {
      xs: 0,
      lg: 3
    }
  }, /*#__PURE__*/_react["default"].createElement(_Ladder["default"], {
    data: carousel
  }))))), /*#__PURE__*/_react["default"].createElement(_Focal["default"], null, focalComponent)));
};

Neapolitan.defaultProps = {
  carousel: [],
  focalComponent: null,
  reverseOnMobile: false,
  navComponent: null
};
Neapolitan.propTypes = {
  carousel: _propTypes["default"].arrayOf(_propTypes["default"].object),
  focalComponent: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].object, _propTypes["default"].array]),
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].object, _propTypes["default"].array]).isRequired,
  navComponent: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].object, _propTypes["default"].array]),
  reverseOnMobile: _propTypes["default"].bool
};
var _default = Neapolitan;
exports["default"] = _default;